import { SolutionServiceMock } from "./solution.types";

export const mockSolutionService = (): SolutionServiceMock => ({
  createSolution: jest.fn(),
});
